import mutationEvents from 'mutation-events'; // Fixes Chrome's depreciation of DOM mutation events

import SwiperInit from './swiper_init';
import FlashNotice from './flash_notice';

(() => {
  document.addEventListener('turbo:load', () => {
    SwiperInit();
    FlashNotice();
	})
})();